import api from '@/api'

const state = {
  informations: [],
  information: null,
  messages: [],
  total: null,
}

// getters
const getters = {
  informations: state => state.informations,
  total: state => state.total
}

// mutation types
const FIND = 'FIND'
const FIND_ONE = 'FIND_ONE'

// actions
const actions = {
  async find({ commit }, { category, page, limit }) {
    const { informations, count } = await api.dynamic.find({ category, page, limit })
    commit(FIND, { informations, total: Math.ceil(count / limit), page })
  },

  async findOne({ commit }, { path, id }) {
    const { information, scienceArticle } = await api.dynamic.findOne({ path, id })
    commit(FIND_ONE, { information: information || scienceArticle })
  },

  async empty({ commit }) {
    const information = null
    commit(FIND_ONE, { information })
  }
}

// mutations
const mutations = {
  [FIND](state, { informations, total, page }) {
    state.informations = informations
    state.messages = state.messages.concat(informations)
    if (page === 1) {
      state.total = total
    }
  },

  [FIND_ONE](state, { information }) {
    state.information = information
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/dynamic.js